import axiosService from './axios-request'
import qs from 'qs'

// POST形式请求
/**
 * userLogin()
 * @param {*} data 
 * @returns 
 * 登录接口
 */
// export const userLogin = data => {
//     return new Promise((resolve, reject) => {
//         axiosService({
//             url: '/login',
//             method: 'POST',
//             data: qs.stringify(data)
//         }).then(response => {
//             resolve(response)
//         }).catch(error => {
//             reject(error)
//         })
//     })
// }

/**
 * 访问信息
 * @param {} data 
 * @returns 
 */
export const setVisitInfor = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/home_visit',
            method: 'GET',
            data: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getHomeList = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/homedate_query',
            method: 'GET',
            data: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getProjectDetail = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/prodetail_query',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 项目、新闻
 */

export const getItemList = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/prolist_query',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 项目分类
 */
export const getProjectClassificatList = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/prolist_info',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 浏览量
 */
export const setPageViewInfo = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/pro_bronum',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}


export const setPassWord = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/login_ip',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

// 提交信息(项目委托专线)
export const setUserInfomation = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/relate_add',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

// 提交信息(项目合伙人委托专线)
export const setProjectPartnerInfo = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/mate_add',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

// 提交信息(项目合伙人委托专线) 不同意理由
export const setProjectPartnerDisagreeInfo = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/matentext_add',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 添加数据(委托专线)
 * /home/project_add
 */
export const setAddDataInfo = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/relateproject_add',
            method: 'POST',
            data: qs.stringify(data)
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 编辑数据(委托专线)
 * /home/project_add
 */
export const setEntrustEditDataInfo = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/relateproject_edit',
            method: 'POST',
            data: qs.stringify(data)
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 查询数据(委托专线)
 */
export const getRelateProjectList = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/relateproject_query',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 添加数据(合伙人委托专线)
 * /home/project_add
 */
export const setPartnerAddDataInfo = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/mateproject_add',
            method: 'POST',
            data: qs.stringify(data)
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 编辑更新(合伙人委托专线)
 */
export const setEditUpdatePartnerAddDataInfo = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/mateproject_edit',
            method: 'POST',
            data: qs.stringify(data)
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 查询数据(合伙人委托专线)
 */
export const getParterRelateProjectList = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/mateproject_query',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const SetEditorUploadImage = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/project_upload',
            method: 'POST',
            data: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 项目进度表
 */
export const getProjectProgressList = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/pacelist_query',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 项目工作流
 */
export const getProjectWorkflowList = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/proworklist_query',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}


/**
 * 确认修改协议
 */
export const setConfirmModificatAgreementInfo  = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/mate_ntype',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 对合约有异议 
 */
export const setDisputeContractInfo = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/matefile_ntype',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}


/**
 * about 简介内容
 */
export const getAboutIntroductList = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/introlist_query',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 下载文件
 */
export const setDownloadFileList = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/introrar_query',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 简介（高层建筑、公共建筑、酒店与地产、城市更新、配套设计）
 */
export const getAboutIntroicList = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/introic_query',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 搜索内容功能
 */
export const setSearchContentList = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/prolist_Select',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}


/**
 * 查询有没有登录
 */
// export const getCheckLoginInfo = data => {
//     return new Promise((resolve, reject) => {
//         axiosService({
//             url: '/home/useriplogin_query',
//             method: 'GET',
//             params: data
//         }).then(response => {
//             resolve(response)
//         }).catch(error => {
//             reject(error)
//         })
//     })
// }

/**
 * vip 登录
 */
export const setUserLoginInfo = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/userip_login',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 
 */

export const getSubmenuIntroicotherListInfo = data => {
    return new Promise((resolve, reject) => {
        axiosService({
            url: '/home/introicother_query',
            method: 'GET',
            params: data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}







// /api/front/index/product/list?page=1&limit=10&cid=0

